import React from 'react'
import {Flex, Text} from '@chakra-ui/react3'
import Icon from '../../components/cms/icon'
import useCtaAction from '../../hooks/useCtaAction'
import PropTypes from 'prop-types'
import CTA from '../../components/cms/cta'

function CardItem({card, headingLevel, styles}) {
    const ctaProps = useCtaAction({
        action: card.cta?.action,
        openInNewTab: card.cta?.openInNewTab
    })
    return (
        <Flex
            data-testid="card"
            aria-label={card?.title}
            {...styles.card}
            {...(ctaProps.href
                ? {as: 'a', ...ctaProps, ...styles.cardLink, _hover: {transform: 'scale(1.01)'}}
                : {})}
        >
            <Flex {...styles.iconText}>
                <Icon {...card.icon} />
                <Text as={`h${headingLevel + 1}`} {...styles.headline} color="text.secondary">
                    {card.headline}
                </Text>
            </Flex>

            <Text {...styles.copy}>{card.copy?.text}</Text>

            <CTA marginTop="24px" variant="text" as="p" {...card.cta} {...styles.cta} />
        </Flex>
    )
}

CardItem.propTypes = {
    card: PropTypes.shape({
        icon: PropTypes.object,
        headline: PropTypes.string,
        copy: PropTypes.shape({
            text: PropTypes.string
        }),
        title: PropTypes.string,
        cta: PropTypes.shape({
            action: PropTypes.shape({
                type: PropTypes.string,
                value: PropTypes.string
            }),
            openInNewTab: PropTypes.bool
        })
    }),
    headingLevel: PropTypes.number,
    styles: PropTypes.object
}

export default CardItem
